<template>
    <vl-sidebar-footer class="kl-sidebar__section kl-sidebar__section-no-border-bottom"
                       v-if="isConfirmVisible || isRemoveVisible">
        <vl-action-group class="kl-sidebar__section__actions">
            <vl-button
                type="button"
                ref="confirmZone"
                v-if="isConfirmVisible"
                @click.prevent="onConfirm"
                :mod-disabled="!editZone"
                mod-block
                mod-small
            >
                Bevestig zone
            </vl-button>
            <vl-button
                type="button"
                v-if="isRemoveVisible"
                ref="removeZone"
                @click.prevent="onRemoveCurrentZone"
                mod-secondary
                mod-error
                mod-small
                class="kl-sidebar__section__actions__button-smaller"
            >
                Verwijder
            </vl-button>
            <vl-button
                type="button"
                ref="revertZone"
                v-if="isConfirmVisible"
                @click.prevent="onRevertCurrentZone"
                mod-tertiary
                mod-small
                class="kl-sidebar__section__actions__button-smaller"
            >
                Annuleren
            </vl-button>
        </vl-action-group>
    </vl-sidebar-footer>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: 'KlDrawZoneSidebarEditFooter',
    emits: ['confirm', 'remove', 'revert'],
    props: {
        isConfirmVisible: {
            type: Boolean,
            required: true,
        },
        isRemoveVisible: {
            type: Boolean,
            required: true,
        },
        editZone: {
            type: Boolean,
            default: false,
        }
    },
    setup(props, { emit }) {
        const onConfirm = () => {
            emit("confirm");
        };
        const onRemoveCurrentZone = () => {
            emit("remove");
        };
        const onRevertCurrentZone = () => {
            emit("revert");
        };
        return {
            onConfirm,
            onRemoveCurrentZone,
            onRevertCurrentZone,
        }
    }
});
</script>

<style scoped>
/* Add any required scoped styles here if necessary */
</style>
